import { handleEvent } from '../../helpers'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

export default class {
  constructor(el) {
    this.DOM = {}

    this.DOM.ul = el.querySelector('ul')
    this.DOM.mobileTrigger = el.querySelector('.burger')
  }

  init() {
    this.handleEvents()
  }

  handleEvents() {
    this.togleHeaderNav_event = handleEvent('click', {
      el: this.DOM.mobileTrigger,
      preventDefault: false,
      stopPropagation: false,
      callback: () => this.toggleHeaderMenu()
    })

    this.closeHeaderNav_event = handleEvent('keydown', {
      el: document,
      preventDefault: false,
      stopPropagation: false,
      callback: this.closeHeaderNav.bind(this)
    })

    // this.togleHeaderNavListListener = handleEvent('click', {
    //   el: this.DOM.ulNav,
    //   preventDefault: false,
    //   stopPropagation: false,
    //   callback: this.toggleHeaderNavList
    // })
  }

  toggleHeaderMenu() {
    if (this.DOM.ul.classList.contains('--menu-is-open')) {
      enableBodyScroll(document.body)
      this.DOM.ul.classList.remove('--menu-animation')
      setTimeout(()=> this.DOM.ul.classList.remove('--menu-is-open'), 300);

      this.DOM.ul.querySelectorAll('li').forEach((el) => {
          el.classList.remove('--activeList');
      });

    } else {
      disableBodyScroll(document.body)
      this.DOM.ul.classList.add('--menu-is-open')

      setTimeout(()=> {
        this.DOM.ul.classList.add('--menu-animation')
      }, 100)

      setTimeout(() => {
        let interval = 100;
        this.DOM.ul.querySelectorAll('li').forEach((el, index) => {
          setTimeout(() => {
            el.classList.add('--activeList');
          }, index * interval);
        });
      },300);
    }
  }

  closeHeaderNav({ keyCode }) {
    if (keyCode !== 27 || !this.DOM.ul.classList.contains('--menu-is-open')) return
    enableBodyScroll(document.body)
    this.DOM.ul.classList.remove('--menu-animation')
    setTimeout(()=> this.DOM.ul.classList.remove('--menu-is-open'), 300)
  }

  // toggleHeaderNavList({ target }) {
  //   if (!target.classList.contains('header-nav__list-boldn')) return
  //   if (target.closest('.--list-is-open')) {
  //     document.querySelector('.--list-is-open').classList
  //       .remove('--list-is-open')
  //   } else {
  //     document.querySelector('.--list-is-open') &&
  //     document.querySelector('.--list-is-open').classList
  //       .remove('--list-is-open')
  //     target.parentElement.classList
  //       .add('--list-is-open')
  //   }
  // }

  destroy() {
    this.togleHeaderNav_event.destroy()
    this.closeHeaderNav_event.destroy()
  }
}
